import type { CustomerForm } from '@entities/customer'

import { useCustomerStore } from '@entities/customer'
import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

interface CustomerUpdateApiOptions {
  customerId: number
  payload: CustomerForm
}

/** `PATCH /admin-api/customers/{customer}` — the whole General info form, flat. */
export const useCustomerUpdateApi = async (options: CustomerUpdateApiOptions): Promise<boolean> => {
  const customerStore = useCustomerStore()

  return runApiWrite(useAdminRoutes('admin.customer.update', { customer_id: options.customerId }), {
    method: 'patch',
    payload: {
      ...options.payload,
      contact_data: { ...options.payload.contact_data },
    },
    setLoading: customerStore.trackProcessing,
  })
}
